<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Tipos de Objeto"
  width="25rem"
  height="35rem"
>
  <ng-template modalContent>
    <div class="content">
      <div class="checkbox-all-select">
        <app-check-box
          class="checkbox"
          [(value)]="isAllSelected"
          label="Todos"
        ></app-check-box>
      </div>

      <div class="list-container">
        <app-list class="list" [items]="objectTypeList">
          <ng-template listItem let-item="item">
            <div class="item">
              <app-check-box
                class="checkbox"
                [value]="isObjectTypeSelected(item)"
                (valueChange)="setObjectTypeSelected(item, $event)"
                [label]="item.label"
              ></app-check-box>
            </div>
          </ng-template>
        </app-list>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="primary"
          styleType="contained"
          text="Aplicar"
          width="100%"
          (click)="onBtnApplyClick()"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Limpar"
          (click)="onBtnClearClick()"
          width="100%"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
